import { render, staticRenderFns } from "./foro.vue?vue&type=template&id=6dfe84d0"
import script from "./foro.vue?vue&type=script&lang=js"
export * from "./foro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports